import React from "react";
import "../../App.css";
import { TabTitle } from "../../utils/GeneralFunctions";

export default function SignUp() {
  TabTitle("Sign-Up-TRVLR");
  return <h1 className="sign-up">SIGN UP</h1>;
}
